import Header from '../components/header'
import Footer from '../components/footer'
import NewsLetter from '../components/newsletter'

import { useState } from 'react';
import axios from 'axios';
import { HelmetProvider } from 'react-helmet-async';

export default function Volunteer() {
    const [fname, setFname] = useState('');
    const [fage, setFage] = useState('');
    const [fgender, setFgender] = useState('');
    const [fgrade, setFgrade] = useState('');
    const [fphone, setFphone] = useState('');
    const [femail, setFemail] = useState('');
    const [fparentphone, setFparentphone] = useState('');
    const [fparentname, setFparentname] = useState('');
  
    const handleSubmit = async (e) => {
        e.preventDefault();
      
        const formData = new FormData();
        formData.append("name", fname);
        formData.append("age", fage);
        formData.append("gender", fgender);
        formData.append("grade", fgrade);
        formData.append("phone", fphone);
        formData.append("email", femail);
        formData.append("parentphone", fparentphone);
        formData.append("parentname", fparentname);

      
        try {
          const res = await axios.post("https://sursaathi.in/volunteer.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          alert("Success: " + res.data.message);
        } catch (err) {
          alert("Failed: " + (err.response?.data?.error || "Unknown error"));
        }
      };    

    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <HelmetProvider>
                <title>about Us</title>
                <meta name="description" content="About the founders and childen of Sur Saathi a Mumbai-based music initiative offering free choir, rhythm, and performance opportunities for children to build confidence and joy." />
                <link rel="canonical" href="https://sursaathi.in/volunteer" />
            </HelmetProvider>
            <Header />
            <div>
                <div className="Donate-Instrument-Section">
                    <div className="graphicelements">
                        <div className="Donate-Wave-Left">
                            <img src="/bg_images/Donate-LeftWave.svg" />
                        </div>
                        <div className="Donate-Wave-Right">
                            <img src="/bg_images/wave-right.svg" /></div>
                        <div className="Donate-Wave-Right-Page">
                            <img src="/bg_images/WaveLine.svg" /></div>
                        <div className="green-note" id="green12">
                            <img src="/bg_images/Artboard-4.svg" /></div>
                        <div className="yellow-note" id="yellow5">
                            <img src="/bg_images/Artboard-3.svg" />
                        </div>
                        <div className="red-note" id="red8">
                            <img src="/bg_images/Artboard-2.svg" />
                        </div>
                    </div>
                    <div className="Donate-Instrument-Section-Info">
                        <h2>Become a Volunteer</h2>
                        <p>
                            Sur Saathi is a community‑driven initiative that uses the power of music to create a safe, inclusive space where every child feels heard and celebrated. Through singing, instrument training, workshops, and free music education, we help children discover their voices and build confidence through creative expression.

                        </p>
                        <div className="Donate-Instrument-Section-Info-Connections">
                            <a href="tel:+918591952169" className="Donate-Instrument-Links-a"><i className="fas fa-phone">
                            </i>+91 8591952169</a>
                            <a href="tel:+917400030602" className="Donate-Instrument-Links-a"><i className="fas fa-phone">
                            </i>+91 7400030602</a>
                            <a href="mailto:sursaathi.music@gmail.com" className="Donate-Instrument-Links-a"><i className="fas fa-envelope">
                            </i>sursaathi.music@gmail.com</a>
                            <a href="https://maps.google.com/?q=Mumbai,+India" target="_blank" rel="noopener noreferrer" className="Donate-Instrument-Links-a"><i className="fas fa-map-marker-alt"></i>Mumbai, IN</a>
                        </div>
                        <div className="Donate-Instrument-Socials">

                            <a href="https://www.instagram.com/sursaathi.music/" className="Donate-Instrument-Socials-a" aria-label="Instagram">

                                <img src="/bg_images/Frame-42.svg" />
                            </a>
                            <a href="https://www.linkedin.com/company/sur-saathi" className="Donate-Instrument-Socials-a" aria-label="LinkedIn">
                                <img src="/bg_images/Frame-43.svg" />
                            </a>
                            <a href="https://www.youtube.com/@Sur-Saathi" className="Donate-Instrument-Socials-a" aria-label="YouTube">
                                <img src="/bg_images/Frame-44.svg" />
                            </a>
                        </div>
                    </div>
                    <div>
                        <form className="donateform" onSubmit={handleSubmit}>
                            <div className="form-input">
                                <label>Full Name</label>
                                <input placeholder="Full Name" type="text" value={fname} onChange={(e) => setFname(e.target.value)} required />
                            </div>
                            <div className="form-input">
                                <label>Age</label>
                                <input placeholder="Age" type="text" value={fage} onChange={(e) => setFage(e.target.value)} required />
                            </div>
                            <div className="form-input">
                                <label>Gender</label>
                                <select value={fgender} onChange={(e) => setFgender(e.target.value)} required>
                                    <option value="">Gender</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Other">Other</option>
                                    <option value="Prefer not to say">Prefer not to say</option>
                                </select>
                            </div>
                            <div className="form-input"><label>Grade</label>
                                <input placeholder="Grade" type="text" value={fgrade} onChange={(e) => setFgrade(e.target.value)} required /></div>
                            <div className="form-input">
                                <label>Phone No</label>
                                <input placeholder="Phone No" type="tel" value={fphone} onChange={(e) => setFphone(e.target.value)} required />
                            </div>
                            <div className="form-input">
                                <label>Email</label>
                                <input placeholder="Email" type="email" value={femail} onChange={(e) => setFemail(e.target.value)} required />
                            </div>
                            <div className="form-input">
                                <label>Parent Name</label>
                                <input placeholder="Parent Name" type="text" value={fparentname} onChange={(e) => setFparentname(e.target.value)} required />
                            </div>
                            <div className="form-input">
                                <label>Parent Phone Number</label>
                                <input placeholder="Parent Phone Number" type="tel" value={fparentphone} onChange={(e) => setFparentphone(e.target.value)} required />
                            </div>
                            <button type="submit">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
            <div>
                <div className="Newsletter-Section">
                    <h2>
                        Stay in Tune with Free Music Education
                    </h2>
                    <p>
                        Get updates on upcoming events, workshops, and ways you can support music education for children across Mumbai — from free music education sessions to chances to donate instruments in Mumbai.
                    </p>
                </div>
            </div>
            <NewsLetter />
            <Footer />
        </div>
    );
}
